import {Injectable} from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import {DuplocateFormDialog} from '../dialogs/duplocate-form.dialog';
import {AssignChainDialog} from '../dialogs/assign-chain.dialog';
import {ConfirmDialog} from '../dialogs/confirm';
import {AlertDialog} from '../dialogs/alert';
import {InfoDialog} from '../dialogs/info';
import {ValidationErrorsDialog} from '../dialogs/validation-errors';

@Injectable({
  providedIn: 'root',
  deps: [DialogService]
})
export class AppDialogService {

  constructor(
    public dialogService: DialogService
  ) {}

  public Alert(header: string, message: string) {
    return this.dialogService.open(
      AlertDialog, {
        header,
        width: '480px',
        style: {top: "15%", position: "fixed"},
        closable: true,
        modal: true,
        focusOnShow: false,
        inputValues: {
          message
        },
      }
    )
  }

  public ValidationErrors(header: string, errors: string[]) {
    return this.dialogService.open(
      ValidationErrorsDialog, {
        header,
        width: '480px',
        style: {top: "15%", position: "fixed"},
        closable: true,
        modal: true,
        focusOnShow: false,
        inputValues: {
          errors
        },
      }
    )
  }

  public Confirm(header: string, message: string) {
    return this.dialogService.open(
      ConfirmDialog, {
        header,
        width: '480px',
        style: {top: "15%", position: "fixed"},
        closable: true,
        modal: true,
        focusOnShow: false,
        inputValues: {
          message
        },
      }
    )
  }

  public AssignChain() {
    this.assignChainDialogRef = this.dialogService.open(
      AssignChainDialog, {
        header: 'Assign Chain',
        width: '480px',
        style: {top: "15%", position: "fixed"},
        closable: true,
        modal: true,
        focusOnShow: false,
      }
    )
  }

  assignChainDialogRef: DynamicDialogRef | undefined;
  duplicateFormDialogRef: DynamicDialogRef | undefined;

  public DuplicateForm() {
    this.duplicateFormDialogRef = this.dialogService.open(
      DuplocateFormDialog, {
        header: 'Duplicate Form',
        width: '480px',
        style: {top: "15%", position: "fixed"},
        closable: true,
        modal: true,
        focusOnShow: false,
      });
  }

}
